// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// import { PiInstagramLogoFill } from "react-icons/pi";
// import { IoLogoWhatsapp } from "react-icons/io";
// import { FaLinkedinIn, FaFacebookSquare, FaTwitter } from "react-icons/fa";

// import Lottie from "lottie-react";
// import bg_circle from "../../../src/animations/bg_circle.json";
// import GetInTouch from "./GetInTouch";

// const Footer = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const pathname = location.pathname.toLowerCase();
//   const isHome = pathname === "/" || pathname === "/home";

//   const handleFooterScroll = (sectionId) => {
//     if (isHome) {
//       const el = document.getElementById(sectionId);
//       el?.scrollIntoView({ behavior: "smooth" });
//     } else {
//       navigate("/", {
//         state: { scrollTo: sectionId },
//       });
//     }
//   };

//   return (
//     <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
//       <GetInTouch />

//       <div className="relative w-full overflow-hidden rounded-t-3xl shadow-custom dark:shadow-white">
//         {/* Background animations */}
//         <div className="absolute lg:hidden right-0 z-0 rotate-180 -mt-32 -mr-32">
//           <Lottie
//             animationData={bg_circle}
//             loop
//             autoplay
//             className="h-[400px] w-[400px]"
//           />
//         </div>

//         <div className="absolute lg:hidden bottom-0 z-0 rotate-180 -mb-32 -ml-28">
//           <Lottie
//             animationData={bg_circle}
//             loop
//             autoplay
//             className="h-[300px] w-[300px]"
//           />
//         </div>

//         <div className="absolute hidden lg:block right-0 bottom-0 z-0 rotate-180 -mb-32 -mr-32">
//           <Lottie
//             animationData={bg_circle}
//             loop
//             autoplay
//             className="h-[400px] w-[400px]"
//           />
//         </div>

//         <div className="absolute hidden lg:block top-0 z-0 rotate-180 -mt-32 -ml-28">
//           <Lottie
//             animationData={bg_circle}
//             loop
//             autoplay
//             className="h-[300px] w-[300px]"
//           />
//         </div>

//         <div className="relative z-10 px-5 lg:px-20 pb-5">
//           <div className="flex flex-col lg:flex-row justify-between gap-10 mt-20">
//             {/* Left section */}
//             <div>
//               <p className="font-semibold text-3xl lg:text-4xl">
//                 Need help with <br /> anything?
//               </p>

//               {/* Social links */}
//               <div className="flex flex-wrap gap-2 mt-10">
//                 <div className="flex items-center">
//                   <a
//                     href="https://www.linkedin.com/company/init-technologyco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
//                   >
//                     <FaLinkedinIn className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-sky-600" />
//                     <span className="origin-left text-sky-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
//                       LinkedIn
//                     </span>
//                   </a>
//                 </div>

//                 <div className="flex items-center">
//                   <a
//                     href="https://www.instagram.com/init.technology"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
//                   >
//                     <PiInstagramLogoFill className="w-7 h-7 shrink-0 text-black dark:text-white group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text" />
//                     <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
//                       Instagram
//                     </span>
//                   </a>
//                 </div>

//                 <div className="flex items-center">
//                   <a
//                     href="https://wa.me/+919664570369?text=Hi%20Init%20Technology,%20I`m%20on%20the%20lookout%20for%20innovative%20solutions,%20and%20your%20services%20caught%20my%20eye.%20Can%20we%20chat%20about%20it%20?"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
//                   >
//                     <IoLogoWhatsapp className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-green-600" />
//                     <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
//                       WhatsApp
//                     </span>
//                   </a>
//                 </div>

//                 <div className="flex items-center">
//                   <a
//                     href="https://www.facebook.com/profile.php?id=61554743413903&mibextid=9R9pXO"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
//                   >
//                     <FaFacebookSquare className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-blue-700" />
//                     <span className="origin-left text-blue-700 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-blue-700 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
//                       Facebook
//                     </span>
//                   </a>
//                 </div>

//                 <div className="flex items-center">
//                   <a
//                     href="https://twitter.com/_inittechnology"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
//                   >
//                     <FaTwitter className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-sky-400" />
//                     <span className="origin-left text-sky-400 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-400 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
//                       Twitter
//                     </span>
//                   </a>
//                 </div>
//               </div>

//               <div className="flex flex-col space-y-2 mt-5">
//                 <a
//                   href="mailto:contact@inittechnology.co"
//                   className="hover:text-teal-600"
//                 >
//                   contact@inittechnology.co
//                 </a>
//                 <a href="tel:+919664570369" className="hover:text-teal-600">
//                   +91-96645 70369
//                 </a>
//               </div>
//             </div>

//             {/* Footer links */}
//             <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 mt-16">
//               <div className="flex flex-col gap-5">
//                 <p className="font-bold">Home</p>

//                 <div>
//                   <button
//                     onClick={() => handleFooterScroll("services")}
//                     className="footer-link"
//                   >
//                     Services
//                   </button>
//                 </div>

//                 <div>
//                   <button
//                     onClick={() => handleFooterScroll("products")}
//                     className="footer-link"
//                   >
//                     Products
//                   </button>
//                 </div>

//                 <div>
//                   <button
//                     onClick={() => handleFooterScroll("how-it-works")}
//                     className="footer-link"
//                   >
//                     How It Works
//                   </button>
//                 </div>
//               </div>

//               <div className="flex flex-col gap-5">
//                 <p className="font-bold">Company</p>
//                 <div>
//                   <button
//                     onClick={() => handleFooterScroll("about-us")}
//                     className="footer-link"
//                   >
//                     About
//                   </button>
//                 </div>

//                 <a href="/blogs" className="footer-link">
//                   Blogs
//                 </a>
//                 <a href="/careers" className="footer-link">
//                   Careers
//                 </a>
//               </div>

//               <div className="flex flex-col gap-5">
//                 <p className="font-bold">Legal</p>

//                 <a href="/terms" className="footer-link">
//                   Terms & Conditions
//                 </a>
//                 <a href="/privacy-policy" className="footer-link">
//                   Privacy Policy
//                 </a>
//               </div>

//               <div className="flex flex-col gap-5">
//                 <p className="font-bold">Help</p>

//                 <div>
//                   <button
//                     onClick={() => handleFooterScroll("contact-us")}
//                     className="footer-link"
//                   >
//                     Contact Us
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-center border-t w-60 mx-auto mt-16">
//             <p className="text-sm text-gray-400 pt-1">
//               Copyright © Init Technology 2025
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;

import React from "react";
import { PiInstagramLogoFill } from "react-icons/pi";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";

import Lottie from "lottie-react";
import bg_circle from "../../../src/animations/bg_circle.json";
import GetInTouch from "./GetInTouch";
import { useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname.toLowerCase();
  const isHome = pathname === "/" || pathname === "/home";

  // const handleFooterScroll = (sectionId) => {
  //   if (isHome) {
  //     const el = document.getElementById(sectionId);
  //     el?.scrollIntoView({ behavior: "smooth" });
  //   } else {
  //     navigate("/", {
  //       state: { scrollTo: sectionId },
  //     });
  //   }
  // };

  const handleFooterScroll = (sectionId) => {
    if (sectionId === "contact-us") {
      const el = document.getElementById("contact-us");
      el?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    if (isHome) {
      const el = document.getElementById(sectionId);
      el?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", {
        state: { scrollTo: sectionId },
      });
    }
  };

  return (
    <div>
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        <GetInTouch />

        <div className="relative w-full h-auto overflow-hidden rounded-t-3xl shadow-custom dark:shadow-white">
          <div className="absolute lg:hidden right-0 z-0 rotate-180 -mt-32 -mr-32">
            {/* <img
              src="../assets/init_bannerBg_light.png"
              alt="Light Background"
              className="w-full h-full object-center object-cover block dark:hidden"
            />
            <img
              src="../assets/init_bannerBg_dark.png"
              alt="Dark Background"
              className="w-full h-full object-center object-cover hidden dark:block"
            /> */}

            <Lottie
              animationData={bg_circle}
              loop={true}
              autoplay={true}
              className="h-[400px] w-[400px]"
              rendererSettings={{
                preserveAspectRatio: "xMidYMid slice",
              }}
            />
          </div>

          <div className="absolute lg:hidden bottom-0 z-0 rotate-180 -mb-32 -ml-28">
            <Lottie
              animationData={bg_circle}
              loop={true}
              autoplay={true}
              className="h-[300px] w-[300px]"
              rendererSettings={{
                preserveAspectRatio: "xMidYMid slice",
              }}
            />
          </div>

          <div className="absolute hidden lg:block right-0 bottom-0 z-0 rotate-180 -mb-32 -mr-32">
            <Lottie
              animationData={bg_circle}
              loop={true}
              autoplay={true}
              className="h-[400px] w-[400px]"
              rendererSettings={{
                preserveAspectRatio: "xMidYMid slice",
              }}
            />
          </div>

          <div className="absolute hidden lg:block top-0 z-0 rotate-180 -mt-32 -ml-28">
            <Lottie
              animationData={bg_circle}
              loop={true}
              autoplay={true}
              className="h-[300px] w-[300px]"
              rendererSettings={{
                preserveAspectRatio: "xMidYMid slice",
              }}
            />
          </div>

          <div className="w-full h-full px-5 lg:px-20 z-10 relative pb-5">
            <div className="h-full grid items-center">
              <div className="flex flex-col lg:flex-row lg:items-center justify-between lg:gap-10">
                <div>
                  <p className="font-semibold text-3xl lg:text-4xl mt-20 transition-all duration-200 ease-in-out">
                    Need help with <br />
                    anything?
                  </p>

                  <div className="flex flex-wrap gap-2 mt-10">
                    <div className="flex items-center">
                      <a
                        href="https://www.linkedin.com/company/init-technologyco"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
                      >
                        <FaLinkedinIn className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-sky-600" />
                        <span className="origin-left text-sky-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                          LinkedIn
                        </span>
                      </a>
                    </div>

                    <div className="flex items-center">
                      <a
                        href="https://www.instagram.com/init.technology"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
                      >
                        <PiInstagramLogoFill className="w-7 h-7 shrink-0 text-black dark:text-white group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text" />
                        <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                          Instagram
                        </span>
                      </a>
                    </div>

                    <div className="flex items-center">
                      <a
                        href="https://wa.me/+919664570369?text=Hi%20Init%20Technology,%20I`m%20on%20the%20lookout%20for%20innovative%20solutions,%20and%20your%20services%20caught%20my%20eye.%20Can%20we%20chat%20about%20it%20?"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
                      >
                        <IoLogoWhatsapp className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-green-600" />
                        <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                          WhatsApp
                        </span>
                      </a>
                    </div>

                    <div className="flex items-center">
                      <a
                        href="https://www.facebook.com/profile.php?id=61554743413903&mibextid=9R9pXO"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
                      >
                        <FaFacebookSquare className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-blue-700" />
                        <span className="origin-left text-blue-700 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-blue-700 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                          Facebook
                        </span>
                      </a>
                    </div>

                    <div className="flex items-center">
                      <a
                        href="https://twitter.com/_inittechnology"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white dark:hover:bg-black relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
                      >
                        <FaTwitter className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-sky-400" />
                        <span className="origin-left text-sky-400 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-400 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                          Twitter
                        </span>
                      </a>
                    </div>
                  </div>

                  <div className="flex flex-col space-y-2 mt-5">
                    <div>
                      <a
                        href="mailto:contact@inittechnology.co"
                        className="relative inline-block group hover:text-teal-600"
                      >
                        contact@inittechnology.co
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                    <div>
                      <a
                        href="tel:+919664570369"
                        className="relative inline-block group hover:text-teal-600"
                      >
                        +91-96645 70369
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 mt-16">
                  <div className="flex flex-col gap-5">
                    <p className="font-bold">Home</p>
                    <div>
                      <button
                        onClick={() => handleFooterScroll("services")}
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Services
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => handleFooterScroll("products")}
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Products
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => handleFooterScroll("how-it-works")}
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        How It Works
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-col gap-5">
                    <p className="font-bold">Company</p>
                    <div>
                      <button
                        onClick={() => handleFooterScroll("about-us")}
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        About
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </button>
                    </div>
                    <div>
                      <a
                        href="/blogs"
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Blogs
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                    <div>
                      <a
                        href="/careers"
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Careers
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                  </div>

                  <div className="flex flex-col gap-5">
                    <p className="font-bold">Legal</p>

                    <div>
                      <a
                        href="/terms-and-conditions"
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Terms & Conditions
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                    <div>
                      <a
                        href="/privacy-policy"
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Privacy Policy
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </div>
                  </div>

                  <div className="flex flex-col gap-5">
                    <p className="font-bold">Help</p>
                    <div>
                      <button
                        onClick={() => handleFooterScroll("contact-us")}
                        className="relative inline-block group text-sm hover:text-teal-600"
                      >
                        Contact Us
                        <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-center mx-auto border-t w-60 mt-16">
                <p className="text-center text-sm text-gray-400 pt-1">
                  Copyright © Init Technology 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
